import cloneDeep from 'clone-deep'
import { TaskAssigneeOptions } from 'pages/Tasks/constants'
import { useEffect, useMemo, useState } from 'react'
import { Modal } from 'stories/components'
import { InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import { taskInputs } from '../constant'

export const AddTask = ({
  data,
  adminEmails,
  tempTasks,
  onClose,
  onSubmit,
}: {
  data: Record<string, any> | null
  adminEmails: string[]
  tempTasks: Array<any>
  onClose: () => void
  onSubmit: Function
}) => {
  const [inputs, setInputs] = useState<Record<string, any>>({})

  const taskOptions = useMemo(() => {
    const options = { ...TaskAssigneeOptions() }
    adminEmails.forEach((email) => (options[email] = email))
    return options
  }, [adminEmails])

  useEffect(() => {
    let temp: any = taskInputs()

    let obj: any = {}
    tempTasks.map((task: any) => {
      obj[`${task.no}`] = `${task.description} - ${task.no}`
    })

    temp = {
      taskTemplateNo: {
        title: 'Choose Template',
        inputType: 'select',
        hasDefaultOption: true,
        options: obj,
        error: '',
        sort: true,
        sortKey: 'value',
      },
      ...temp,
    }

    temp['assignedTo'].options = taskOptions
    temp['assignedToSecondary'].options = taskOptions
    temp['assignedToManager'].options = taskOptions
    temp['replyCcUser'].options = taskOptions

    if (data) {
      Object.keys(temp).map((key) => {
        temp[key].value = data[key] ?? temp[key].value
      })
    }
    setInputs(temp)
  }, [])

  const onChange = (key: string, value: any) => {
    const temp = cloneDeep(inputs)
    temp[key].value = value
    if (key === 'taskTemplateNo') {
      const template = tempTasks.find((item) => item.no == value)
      let tInputs: any = taskInputs()
      Object.keys(tInputs).map((key) => {
        inputs[key].value = tInputs[key].value
      })

      Object.keys(inputs)
        .filter((key) => key !== 'taskTemplateNo')
        .map((key: string) => {
          temp[key].value = template[key] || tInputs[key].value
          temp[key].error = ''
        })
    }
    setInputs(temp)
  }

  const _onSubmit = () => {
    let hasError = false

    let newInputs = cloneDeep(inputs)
    const data: Record<string, any> = {}
    for (const key in inputs) {
      if (key === 'taskTemplateNo') continue
      if (newInputs[key].value && newInputs[key].value.trim) newInputs[key].value = newInputs[key].value.trim()
      newInputs[key].error = InputValidate(newInputs[key])
      data[key] = newInputs[key].value
      if (newInputs[key].error) hasError = true
    }
    if (hasError) {
      setInputs(newInputs)
      return
    }

    onSubmit(data)
  }

  return (
    <Modal title={`${data ? 'Edit' : 'Add'} Task`} isOpen onClose={onClose} onOk={_onSubmit}>
      <div className="grid grid-cols-2 gap-4 w-[600px] pb-48">
        {Object.keys(inputs).map((key: string) => {
          const input = inputs[key]
          if (key === 'notes') input.span = 'full'

          return (
            <div className={`col-span-${input.span || 1}`}>
              <RenderInput input={input} Key={key} onChange={onChange} />
            </div>
          )
        })}
      </div>
    </Modal>
  )
}
